import { createSelector } from 'reselect'

export const selector = (state) => state.elements.modals.policyMigrator

export const getVisible = createSelector(
  selector,
  ({ visible }) => visible
)
